import * as React from "react";
import CloseIcon from "@material-ui/icons/Close";
import "./createNewWord.scss";
import { Button, CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getVocabularySearchedWord } from "../../../../redux/actions/vocabularyCenterAction";
import { NON_CASE_SENSITIVE, USER } from "../../../../redux/constants";
import AddWords from "../AddWords/AddWords";
import translate from "../../../../i18n/translate";

const CreateNewWord = ({ handleClose }: any) => {
  const dispatch = useDispatch();
  const reduxState = useSelector((state: any) => state);
  const [searchedWord, setSearchedWord] = React.useState<string>("");
  const [searchDetails, setSearchDetails] = React.useState<any>({});

  React.useEffect(() => {
    if (
      reduxState &&
      reduxState.vocabularyContents &&
      reduxState.vocabularyContents.isWordSearching !== null &&
      !reduxState.vocabularyContents.isWordSearching
    ) {
      const isErrorOccurred = reduxState.vocabularyContents.searchedWordError;
      if (reduxState.vocabularyContents.isSearchedWordDetailsAvailable && Object.keys(isErrorOccurred).length < 1) {
        const searchedWord = reduxState.vocabularyContents.searchedWordDetails.word;
        setSearchDetails(searchedWord[0]);
      } else {
        setSearchDetails({
          showMessage: true,
          message: translate("vocab_center_new_word_message"),
        });
      }
    } else {
      setSearchDetails({});
    }
  }, [reduxState]);

  const handleSearch = (e: any) => {
    if (e && e.key && e.key.toUpperCase() === "ENTER") {
      dispatch(
        getVocabularySearchedWord(
          reduxState.common.lgId,
          reduxState.peopleInformation.data.getpeopleInformation.token,
          searchedWord,
          USER,
          NON_CASE_SENSITIVE
        )
      );
    }
  };

  return (
    <div className="create-new-word-container">
      {reduxState.vocabularyContents.isWordSearching ? (
        <div className="pop-up-loading">
          <CircularProgress size={25} color="primary" />
        </div>
      ) : Object.keys(searchDetails).length > 0 ? (
        <AddWords handleClose={handleClose} newWordTitle={searchedWord} />
      ) : (
        <>
          <div className="title-container">
                <p className="new-word-label">{translate("vocab_center_new_word_text")}</p>
            <CloseIcon className="close-icon" onClick={handleClose} />
          </div>
          <div className="search-box">
                <label className="search-label">{translate("vocab_center_enter_word_text")}:</label>
            <input
              type="text"
              className="search-bar"
              maxLength={40}
              value={searchedWord}
              onChange={(e) => setSearchedWord(e.target.value)}
              onKeyPress={handleSearch}
            />
          </div>
          <div className="button-container">
            <Button variant="contained" className="save-button" onClick={() => handleSearch({ key: "ENTER" })}>
              {translate("vocab_center_save_text")}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default CreateNewWord;
